// Bootstrap requires bootstrap.js to be globally available
import 'bootstrap-sass/assets/javascripts/bootstrap';

// Import custom framework css
import 'style/bootstrap/amazonauthor_bootstrap.scss';
import 'style/semantic/amazonauthor_semantic.scss';

// Import css which is loaded on every page
import './AmazonAuthor.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { metrics } from 'react-metrics';

import provideTranslations from 'decorators/provideTranslations';
import EelMetricsApi from 'sdk/EelMetrics';
import ClientSideErrorActionCreator from 'actions/errors/ClientSideErrorActionCreator';
import ClientSideMetrics from '../utils/ClientSideMetrics';

@metrics(EelMetricsApi.reactMetricsConfig())
@provideTranslations('core')
class AmazonAuthor extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    // These props are added by the router
    location: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { isRefreshing: false };
  }

  componentDidMount() {
    window.onerror = (message, file, lineNum, columnNum, error) => {
      const { location } = this.props;
      ClientSideErrorActionCreator.log(message, error, location.pathname + location.search);
      ClientSideMetrics.error(error, file, message);
    };
  }

  render() {
    if (this.state.isRefreshing) {
      // Render a div to avoid temporarily showing our 404 page while we refresh
      return <div />;
    }
    return this.props.children;
  }
}

export default AmazonAuthor;
